import type { FC, ReactNode } from 'react';
import { SectionLabel } from './typography';
import styles from './SectionCard.module.css';

interface SectionCardProps {
  label?: ReactNode;
  rightSlot?: ReactNode;
  children: ReactNode;
  className?: string;
  tight?: boolean;
  testId?: string;
}

export const SectionCard: FC<SectionCardProps> = ({
  label,
  rightSlot,
  children,
  className,
  tight = false,
  testId,
}) => {
  const hasHeader = label !== undefined || rightSlot !== undefined;
  const rootClass = [styles.card, tight && styles.tight, className].filter(Boolean).join(' ');

  return (
    <section className={rootClass} data-testid={testId}>
      {hasHeader && (
        <div className={styles.header}>
          {label !== undefined ? <SectionLabel>{label}</SectionLabel> : <span />}
          {rightSlot !== undefined && rightSlot !== null && (
            <div className={styles.rightSlot}>{rightSlot}</div>
          )}
        </div>
      )}
      {children}
    </section>
  );
};
